import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DialogModule } from 'primeng/dialog';
import { OverlayModule } from 'primeng/overlay';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TooltipModule } from 'primeng/tooltip';
import { WidgetModule } from '../modules/component/widget/widget.module';
import { FormHelperModule } from '../shared/form/form-hepler.module';
import { ImageUploadModule, SharedModule } from '../shared/shared.module';
import { ChangePasswordComponent } from './component/change-password/change-password.component';
import { ChatboxComponent } from './component/chatbox/chatbox.component';
import { EmailSenderComponent } from './component/email-sender/email-sender.component';
import { SearchModalComponent } from './component/search-modal/search-modal.component';
import { UserFooterComponent } from './component/user-footer/user-footer.component';
import { UserHeaderComponent } from './component/user-header/user-header.component';
import { UserLeftSideBarComponent } from './component/user-left-side-bar/user-left-side-bar.component';
import { UserRightSideBarComponent } from './component/user-right-side-bar/user-right-side-bar.component';
import { FloatPatientWaitingListComponent } from './component/float-patient-waiting-list/float-patient-waiting-list.component';
import { LicenseEndComponent } from './component/license-end/license-end.component';
import { FeatureModalModule } from "src/app/shared/feature-modal/feature-modal.module";
@NgModule({
  declarations: [
    UserHeaderComponent,
    UserFooterComponent,
    UserRightSideBarComponent,
    UserLeftSideBarComponent,
    EmailSenderComponent,
    ChangePasswordComponent,
    SearchModalComponent,
    ChatboxComponent,
    FloatPatientWaitingListComponent,
    LicenseEndComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    ImageUploadModule,
    FormHelperModule,
    SharedModule,
    DialogModule,
    WidgetModule,
    TooltipModule,
    OverlayModule,
    OverlayPanelModule,
    FeatureModalModule
  ],
  exports: [UserFooterComponent, UserHeaderComponent, UserRightSideBarComponent, UserLeftSideBarComponent, ChatboxComponent, FloatPatientWaitingListComponent]
})
export class CoreModule { }
